export default __webpack_public_path__ + "static/media/single-project-page-05-img-25.3632b90b.jpg";